import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
/**
 * 标签输入框组件，继承Base
 * @module $ui/components/my-tree-select
 */
import TreeSelect from '../common/TreeSelect';
import Base from '../Base';
export default {
  name: 'MyTreeSelect',
  mixins: [Base],
  components: {
    TreeSelect: TreeSelect
  },
  props: {
    value: [Array, String, Number]
  },
  computed: {
    inputSize: function inputSize() {
      if (this.size) return this.size;
      if (this.myForm) {
        return this.myForm.$attrs.size || '';
      }
      return '';
    }
  },
  methods: {
    getDefaultValue: function getDefaultValue() {
      return this.$attrs.multiple ? [] : '';
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var scopedSlots = this.$scopedSlots.default ? {
      default: function _default(props) {
        return _this.$scopedSlots.default(props);
      }
    } : null;
    var vnode = h(TreeSelect, _mergeJSXProps([{
      "ref": 'comp'
    }, {
      props: _objectSpread(_objectSpread({}, this.innerProps), {}, {
        size: this.inputSize
      }),
      on: _objectSpread({}, this.$listeners),
      scopedSlots: scopedSlots
    }, {
      "attrs": {
        "size": this.inputSize,
        "options": this.options,
        "keyMap": this.keyMap
      },
      "model": {
        value: _this.fieldValue,
        callback: function callback($$v) {
          _this.fieldValue = $$v;
        }
      }
    }]));
    return this.renderComponent(vnode);
  }
};